export default __webpack_public_path__ + "static/media/breakfast.e6e59f28.png";